import { Container, Row } from "react-bootstrap";
import { useEffect } from "react";
import Gallery from "./Gallery";
import ReviewsCarousel from "./ReviewsCarousel";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const About = () => {
  const windowHeight = window.innerHeight;

  useEffect(() => {
    const reveal = (className) => {
      var reveals = document.querySelectorAll(className);

      for (var i = 0; i < reveals.length; i++) {
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 150;

        if (elementTop < windowHeight - elementVisible) {
          reveals[i].classList.add("active");
        } else {
          reveals[i].classList.remove("active");
        }
      }
    };

    window.addEventListener("scroll", () => {
      reveal(".reveal");
      reveal(".reveal2");
      reveal(".reveal3");
      reveal(".reveal4");
    });

    reveal(".reveal");
    reveal(".reveal2");
    reveal(".reveal3");
    reveal(".reveal4");

    return () => {
      window.removeEventListener("scroll", () => {
        reveal(".reveal");
        reveal(".reveal2");
        reveal(".reveal3");
        reveal(".reveal4");
      });
    };
  }, [windowHeight]);

  return (
    <>
      <Helmet>
        <title>O nas | Anten-Sat</title>
        <meta
          name="description"
          content="Poznaj naszą firmę ANTEN-SAT. Specjalizujemy się w montażu i ustawianiu anten w Częstochowie i okolicach."
        />
        <link rel="canonical" href="https://antensat.pl/about" />
      </Helmet>

      <Container fluid className="hero">
        <Row className="p-4">
          <h1 className="reveal3">NASZA HISTORIA</h1>
          <p className="reveal">
            Od ponad 20 lat dostarczamy nowoczesne rozwiązania w zakresie
            telewizji, monitoringu i automatyki.
          </p>
          <img
            src="/img/Timeline.png"
            className="img-fluid reveal2"
            alt="Logo"
          />
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 text-center reveal4">
          <h1 className="text-start">GALERIA WYKONANYCH PRAC</h1>
          <Gallery />
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4">
          <h1 className="reveal3">OPINIE NASZYCH KLIENTÓW</h1>
          <ReviewsCarousel />
          <p className="my-4">
            Wszystkie te opinie możesz znaleźć na naszym{" "}
            <Link
              to="https://maps.app.goo.gl/4ZYT9FtL2vwmaBB79"
              target="_blank"
            >
              Google
            </Link>
            .
          </p>
        </Row>
        <hr className="custom-hr" />
      </Container>
    </>
  );
};

export default About;
//
